import DatabaseManagerStore from 'views/admin/DatabaseManager/DatabaseManagerStore';
import type RootStore from 'stores/RootStore';
import { RouteType } from 'types/RouteType';

const databaseManagerRoute: RouteType = {
  name: 'Database Manager',
  path: '/database-manager/:servicePath',
  defaultParams: { servicePath: 'activate-user' },
  layout: '/admin',
  viewportCard: {
    header: {
      title: 'Database Manager',
      enableRefreshButton: true,
      enableBackButton: true,
      color: 'primary',
      component: () => import('./DatabaseManager.Header'),
    },
    body: {
      component: () => import('./DatabaseManager.Body'),
      grayBackground: false,
    },
  },
  dialogs: [
    {
      name: 'EntityViewerDialog',
      title: 'Entity Viewer',
      component: () => import('./DatabaseManager.EntityDialog'),
      // Neither was set, so this resolved to `maxWidth: 'xl'` at 400px tall —
      // an extremely wide, extremely short box over a record that can carry 47
      // fields. A record viewer is a tall, narrow shape.
      maxWidth: 'sm',
      height: 620,
    },
  ],
  group: 'Admin',
  searchAliases: ['db', 'tables', 'sql'],
  requiresAuth: true,
  requiresAdmin: true,
  requiresPermission: false,
  enableAutoFind: false,
  channels: [':servicePath'],
  beforeEnter: async ({ rootStore }: { rootStore: RootStore }) => {
    const databaseManagerStore =
      rootStore.databaseManagerStore as DatabaseManagerStore;
    databaseManagerStore.findServiceStores();
    return true;
  },
};

export default databaseManagerRoute;
